// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { z } from 'zod';
export const weightSubtractionId = (z.number());
export const weightSubtraction = z.object({
    id: weightSubtractionId,
    fermentation_id: fermentationId.nullable(),
    total_g: z.string().nullable(),
    created_at: z.date(),
    description: z.string().nullable(),
});
export const weightSubtractionInitializer = z.object({
    id: weightSubtractionId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    total_g: z.string().optional().nullable(),
    created_at: z.date().optional(),
    description: z.string().optional().nullable(),
});
export const weightSubtractionMutator = z.object({
    id: weightSubtractionId.optional(),
    fermentation_id: fermentationId.optional().nullable(),
    total_g: z.string().optional().nullable(),
    created_at: z.date().optional(),
    description: z.string().optional().nullable(),
});
//# sourceMappingURL=WeightSubtraction.js.map